module.exports = __webpack_public_path__ + "separator-92fdef8200c20682c52d45f80fa804cf.svg";